import { e as s } from "./directive-B5s9Ooqi.js";
import { e as r } from "./unsafe-html-BQFfCuri.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class e extends r {
}
e.directiveName = "unsafeSVG", e.resultType = 2;
const m = s(e);
export {
  m as o
};
//# sourceMappingURL=unsafe-svg-By8nNw37.js.map
